import React, { Component } from 'react'
import CodeMirror from 'codemirror'
import 'codemirror/addon/selection/active-line'
import 'codemirror/addon/selection/mark-selection'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/mode/clike/clike'
import 'codemirror/mode/css/css'
import 'codemirror/mode/python/python'
import 'codemirror/mode/htmlembedded/htmlembedded'

class Editor extends Component {
  componentDidMount() {
    this.editor = CodeMirror(this._editor, {
      mode: this.props.mode,
      lineWrapping: false,
      autofocus: true,
      coverGutterNextToScrollbar: true,
      styleActiveLine: true,
      lineNumbers: true,
      theme: 'one-dark',
      tabSize: 2,
      undoDepth: 0
    })

    if (this.props.init) this.props.init(this.editor)
    if (this.props.active) this.props.loadFile(this.props.active)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.active !== this.props.active && this.props.active)
      this.props.loadFile(this.props.active)
  }

  render() {
    return <div ref={(elem) => (this._editor = elem)} className='editor' />
  }
}

export default Editor
